import React, { useState, useEffect, useRef  } from 'react';
import '../Assessments/assessment.css'; // You can style the components here
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { MdOutlineCenterFocusWeak } from "react-icons/md";
import {  LuTarget } from "react-icons/lu";
import Alert from '@mui/material/Alert';
import { Navigate } from 'react-router-dom';
import { db, auth, st} from '../Firebase_Config/firebase';
import { collection, addDoc, getDoc, query, where, orderBy, limit,  doc, updateDoc, setDoc, getDocs } from 'firebase/firestore';
import { getStorage, ref, listAll, deleteObject, uploadBytes, getDownloadURL, updateMetadata, getMetadata  } from 'firebase/storage';
import axios from 'axios';


//Function Save the answers to firebase 
const saveAnswersToFirebase = async (answers, userId) => {
  try {
    const userDocRef = doc(db, 'Answers', userId);
    // Combine answers with formattedAnswers into a single object
    const formattedAnswers = {
      ConformityAnalysis: answers, // Save answers under the "EssentialsAssessment" field
    };
    
    await setDoc(userDocRef, formattedAnswers, { merge: true }); // Merge updates into the existing document
    console.log('Answers saved to Firebase.');
  } catch (error) {
    console.error('Error saving answers to Firebase:', error);
  }
};

// Function to load answers from Firebase
const loadUserAnswersFromFirebase = async (userId) => {
  try {
    const userDocRef = doc(db, 'Answers', userId);
    const userAnswers = await getDoc(userDocRef);
    
    if (userAnswers.exists()) {
      const data = userAnswers.data();
      return data.ConformityAnalysis || {}; // Return the EssentialsAssessment data or an empty object
    } else {
      console.log('No answers found.');
      return {}; // Return an empty object if the document doesn't exist
    }
  } catch (error) {
    console.error('Error loading answers from Firebase:', error);
    return {}; // Return an empty object in case of error
  }
};


// Modal Component for Updating Progress
const ProgressModal = ({ 
  isOpen, 
  onClose, 
  onSave, 
  currentProgress, 
  savedComment,
  goal,
  goalID,
  group
}) => {
  const [progressValue, setProgressValue] = useState(currentProgress || null);
  const [comment, setComment] = useState(savedComment || '');
  const [error, setError] = useState('');
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const storage = getStorage();

  useEffect(() => {
    setProgressValue(currentProgress); // Update state when modal opens with new props
    setComment(savedComment);
  }, [currentProgress, savedComment]);

  useEffect(() => {
    if (group && goal) {
      fetchUploadedFiles(group, goal, goalID);
    }
  }, [group, goal, goalID]);

  const getUserId = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const userId = searchParams.get('id');
    return userId;
  };

  const fetchUploadedFiles = async (group, goal, question) => {
    const assessment = 'ConformityAssessment'; // Hardcoded assessment name
    try {
      const userId = getUserId();
      const storageRef = ref(storage, `evidence/${userId}/${assessment}/${group}/${goal}/${question}`);
      const fileList = await listAll(storageRef);
  
      const files = await Promise.all(
        fileList.items.map(async (item) => {
          try {
            const url = await getDownloadURL(item);
            const metadata = await getMetadata(item);
            const approved = metadata.customMetadata?.approved === 'true';
  
            return { name: item.name, url, approved };
          } catch (error) {
            if (error.code === 'storage/object-not-found') {
              console.warn(`File ${item.name} not found, skipping...`);
              return null;
            } else {
              console.error('Error fetching file URL: ', error);
              return null;
            }
          }
        })
      );
  
      // Filter out invalid files
      const validFiles = files.filter((file) => file !== null);
      setUploadedFiles(validFiles); // Update state for UI
    } catch (error) {
      console.error('Error fetching uploaded files: ', error);
      alert('Error fetching uploaded files.');
    }
  };


  const handleApprovalChange = async (file, index, group, goal,  question) => {
    const newApprovalStatus = !file.approved; // Toggle the approval status
  
    try {
      const userId = getUserId(); // Fetch the current user ID
      const assessment = 'ConformityAssessment';
      
      // Reference the file in the structured storage path
      const fileRef = ref(
        storage,
        `evidence/${userId}/${assessment}/${group}/${goal}/${question}/${file.name}`
      );
  
      // Update the metadata to toggle the approval status
      await updateMetadata(fileRef, {
        customMetadata: { approved: newApprovalStatus.toString() },
      });
  
      // Once the backend update is successful, update the local state
      const updatedFiles = [...uploadedFiles];
      updatedFiles[index] = { ...file, approved: newApprovalStatus }; // Update the approval status in the local state
      setUploadedFiles(updatedFiles); // Reflect the new approval status locally
  
      console.log('Approval status successfully updated on backend.');
    } catch (error) {
      console.error('Error updating approval status:', error);
      alert('Failed to update approval status. Please try again.');
    }
  };
  
  
  //Save button in the Pop up menu 
  const handleSave = () => {
    // Validate the progress value if checkbox is not selected
    if (progressValue === null || !Number.isInteger(Number(progressValue)) || progressValue < 0 || progressValue > 100) {
      setError('Please enter a whole number between 0 and 100');
      return;
    }
    setError('');
    // If the checkbox is checked, save the percentage as null and set the flag
    onSave( progressValue, comment, );
  };
  

  if (!isOpen) return null; // Don't render if the modal is closed
 //HTML for the pop up menu
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>Progress Update</h3>
        {error && <Alert variant="filled" severity="error" className="error-message">{error}</Alert>}
        <label>Current Progress (Expected: 100%)</label>
        <input
          type="number"
          value={progressValue !== null ? progressValue : ''} // Display empty if progressValue is null
          onChange={(e) => setProgressValue(e.target.value === '' ? null : Number(e.target.value))}
          min="0"
          max="100"
          step="1"
          placeholder="Enter progress"
        />
        <textarea
          placeholder="Enter Your Remarks Here"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
        />
        <div>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr className='File-header'>
                <th style={{ textAlign: 'left', padding: '8px' }}>File Name</th>
                <th style={{ textAlign: 'center', padding: '8px' }}>Approval</th>
              </tr>
            </thead>
            <tbody>
              {uploadedFiles.map((file, index) => (
                <tr key={index} style={{ borderBottom: '1px solid #ddd' }}>
                  <td style={{ padding: '8px' }}>
                  <a
                    href={file.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'none', color: 'blue' }}
                  >
                    {file.name}
                  </a>
                  </td>
                  <td style={{ textAlign: 'center', padding: '8px' }}>
                  <label>
                    <input
                      type="checkbox"
                      checked={file.approved}  // Use the locally fetched approval status
                      onChange={() => handleApprovalChange(file, index, group, goal, goalID)}  // Trigger the backend update when clicked
                    />
                    <span className="Assessmentcheckbox"></span>
                    {file.approved ? "Approved" : "Pending Approval"}  {/* Display status based on local state */}
                  </label>                    
                  </td> 
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <br/>
        <div className="modal-actions">
          <button onClick={onClose}>Cancel</button>
          <button onClick={handleSave}>Save</button>
        </div>
      </div>
    </div>
  );
};



const CollapsibleTitle = ({ title, children, answers, groupTitle, setAnswers }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [average, setAverage] = useState(0);

  const prevGroupAverage = useRef(null); // Store the previous group average

  useEffect(() => {
    // Calculate average for this group based on goals' averages
    const goalAverages = React.Children.map(children, (child) =>
      child.props.goal
        ? child.props.goal.requirements.map(
            (req) =>
              answers[groupTitle]?.[child.props.goal.PreGoal]?.[req.id]?.percentage || 0
          )
        : []
    ).flat();

    const totalAverage =
      goalAverages.reduce((sum, value) => sum + value, 0) / goalAverages.length;

    const computedAverage = isNaN(totalAverage) ? 0 : totalAverage;

    // Only update state if the new average is different from the previous one
    if (prevGroupAverage.current !== computedAverage) {
      setAverage(computedAverage);
      prevGroupAverage.current = computedAverage;

      // Update answers structure with group average
      if (setAnswers) {
        setAnswers((prevAnswers) => ({
          ...prevAnswers,
          [groupTitle]: {
            ...prevAnswers[groupTitle],
            GroupAverage: computedAverage, // Store the group average here
          },
        }));
      }
    }
  }, [answers, children, groupTitle, setAnswers]);

  return (
    <div className="collapsible">
      <div className="collapsible-header">
        <div className="arrow" onClick={() => setIsOpen(!isOpen)}>
          <MdOutlineCenterFocusWeak className="AIicon2" />
          {isOpen ? <IoIosArrowUp /> : <IoIosArrowDown />}
          <span>{`${title}`}</span>
        </div>
        <div className="collapsible-status">
          <div className="progress-bar-container">
            <div
              className="progress-bar"
              style={{ width: `${average.toFixed(1)}%` }}
            ></div>
          </div>
          <span>{average.toFixed(1)}%</span>
        </div>
      </div>

      {isOpen && (
        <div className="collapsible-content">
          {React.Children.map(children, (child, index) =>
            React.cloneElement(child, {
              // Pass the update function to child goals
            })
          )}
        </div>
      )}
    </div>
  );
};

const CollapsiblePreGoal = ({ title, children, average }) => {
  const [isOpen, setIsOpen] = useState(false);
 
  return (
    <div className="collapsible">
      <div className="collapsible-header">
        <div className="arrow" onClick={() => setIsOpen(!isOpen)}>
          <MdOutlineCenterFocusWeak className="AIicon2" />
          {isOpen ? <IoIosArrowUp /> : <IoIosArrowDown />}
          <span>{title}</span>
        </div>
        <div className="collapsible-status">
          <div className="progress-bar-container">
            <div
              className="progress-bar"
              style={{ width: `${average}%` }}
            ></div>
          </div>
          <span>{average}%</span>
        </div>
      </div>

      {isOpen && (
        <div className="collapsible-content">
          {React.Children.map(children, (child, index) =>
            React.cloneElement(child, {
               // Pass the update function to child goals
            })
          )}
        </div>
      )}
    </div>
  );
}




const CollapsibleGoal = ({ goal, groupTitle, setAnswers, answers}) => {
  const [goalPercentages, setGoalPercentages] = useState([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [chatHistory, setChatHistory] = useState([]);
  const [input, setInput] = useState('');
  const [isTyping, setIsTyping] = useState(false);
  const [average, setAverage] = useState(0);

  useEffect(() => {
    // Calculate average for this goal based on requirements' percentages
    const percentages = goal.requirements.map(
      (req) => answers[groupTitle]?.[goal.PreGoal]?.[req.id]?.percentage || 0
    );
    const goalAverage =
      percentages.reduce((sum, value) => sum + value, 0) / percentages.length;
    setAverage(isNaN(goalAverage) ? 0 : goalAverage);
  }, [answers, groupTitle, goal]);

  const handleOpenModal = async (content) => {
    try {
      setModalOpen(true);
      setIsTyping(true);

      // Hidden first user message (not shown in UI)
      const hiddenUserMessage = { role: 'USER', message: `Explain this in non-technical terms: ${content}` };

      const response = await axios.post(
        'https://api.cohere.ai/v1/chat',
        {
          message: hiddenUserMessage.message,
          chat_history: [],
        },
        {
          headers: {
            Authorization: `Bearer jAzSNerksrFfK85So9QvdimVTzckEmeFKGdQw3yD`,
            'Content-Type': 'application/json',
          },
        }
      );

      const botResponse = response.data.text.trim();
      const botMessage = { sender: 'bot', text: botResponse };

      // ✅ Show only the bot’s message in UI
      setMessages([botMessage]);

      // ✅ Save both hidden user message and bot reply in chat history
      setChatHistory([hiddenUserMessage, { role: 'CHATBOT', message: botResponse }]);

      setIsTyping(false);
    } catch (error) {
      console.error('Error fetching response from Cohere AI:', error);
      setMessages([{ sender: 'bot', text: 'Error generating response. Please try again.' }]);
      setIsTyping(false);
    }
  };
      
  const sendMessage = async (e) => {
    e.preventDefault();
    if (input.trim() === '') return;

    const userMessage = { sender: 'user', text: input };
    setMessages((prev) => [...prev, userMessage]);
    setIsTyping(true);
    setInput('');

    try {
      const response = await axios.post(
        'https://api.cohere.ai/v1/chat',
        {
          message: input,
          chat_history: chatHistory, // Use hidden + visible history
        },
        {
          headers: {
            Authorization: `Bearer jAzSNerksrFfK85So9QvdimVTzckEmeFKGdQw3yD`,
            'Content-Type': 'application/json',
          },
        }
      );

      const botResponse = response.data.text.trim();
      const botMessage = { sender: 'bot', text: botResponse };

      // ✅ Update UI
      setMessages((prev) => [...prev, botMessage]);

      // ✅ Update hidden history
      setChatHistory((prev) => [
        ...prev,
        { role: 'USER', message: input },
        { role: 'CHATBOT', message: botResponse },
      ]);

      setIsTyping(false);
    } catch (error) {
      console.error('Error generating response:', error);
      setMessages((prev) => [
        ...prev,
        { sender: 'bot', text: 'Error generating response. Please try again.' },
      ]);
      setIsTyping(false); 
    }
  };   

  const handleInputChange = (e) => {
    setInput(e.target.value);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setMessages([]);
    setChatHistory([]);
  };
 

   

  return (
    <div className="collapsible">
      <CollapsiblePreGoal
        title={`${goal.PreGoal} ${goal.goal}`}
        average= {average.toFixed(1)}
        savedData={goal.requirements.map(requirement => ({
          percentage: answers[groupTitle]?.[goal.PreGoal]?.[requirement.id]?.percentage || 0,
          comment: answers[groupTitle]?.[goal.PreGoal]?.[requirement.id]?.comment || '',
        }))}
      >
         {goal.requirements.map((requirement, requirementIndex) => {
          // Access the saved data for this specific requirement
          const savedData =
            answers[groupTitle]?.[goal.PreGoal]?.[requirement.id] || {
              percentage: null,
              comment: '',
            };
            console.log(savedData)

          return (
            <CollapsibleRequirement
              key={requirement.id}
              requirement={requirement}
              groupgoal={goal.PreGoal}
              groupTitle={groupTitle}
              setAnswers={setAnswers}
              answers={answers}
              savedAnswers={savedData} // Pass the saved data for the requirement
            >
              <div className="AsessmentContainerBox">
                <table className="assessment-table">
                  <thead>
                    <tr className="File-header">
                      <th className="header-cell">Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="question-text-container">
                        <div
                          className="question-text"
                          
                          onClick={() => handleOpenModal(requirement.text)} dangerouslySetInnerHTML={{ __html: requirement.text }}
                        ></div>
                        <Modal
                          isOpen={isModalOpen}
                          onClose={handleCloseModal}
                          messages={messages}
                          isTyping={isTyping}
                          input={input}
                          handleInputChange={handleInputChange}
                          sendMessage={sendMessage}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </CollapsibleRequirement>
          );
        })}
      </CollapsiblePreGoal>
    </div>
  );
};


const CollapsibleRequirement = ({ requirement,children, setAnswers, answers, groupTitle, savedAnswers, groupgoal}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleModalSave = (newPercentage, comment) => {
    const updatedAnswers = {
      ...answers,
        [groupTitle]: {
          ...(answers[groupTitle] || {}),
          [groupgoal]: {
            ...(answers[groupTitle]?.[groupgoal] || {}),
            [requirement.id]: {
              percentage: newPercentage,
              comment: comment,
            },
          },
        },
      }
    setAnswers(updatedAnswers);
    setIsModalOpen(false);
  };

  

  return (
    <div className="collapsible">
      <div className="collapsible-header-2nd">
        <div className="arrow" onClick={() => setIsOpen(!isOpen)}>
          <LuTarget className='AIicons'/>
          {isOpen ? <IoIosArrowUp /> : <IoIosArrowDown />}
          <span>{requirement.id} - {requirement.text.split(' ').slice(0, 6).join(' ') + '...'}</span>
        </div>
        <div className="collapsible-status">
          <div className="progress-bar-container">
            <div
              className="progress-bar"
              style={{
                width: `${savedAnswers?.percentage || 0}%`,  // Ensure valid progress width, default to 0
                backgroundColor: savedAnswers?.percentage > 0 ? '#f04438' : '#ddd',  // Color based on progress
              }}
            ></div>
          </div>
          <span>{savedAnswers?.percentage}%</span>
          <span>Progress</span>
          <div className="kebab-menu" onClick={() => setIsModalOpen(true)}>
            &#8942;
          </div>
        </div>
      </div>

      {isOpen && <div className="collapsible-content">{children}</div>}
      <ProgressModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        currentProgress={savedAnswers?.percentage || null}
        savedComment={savedAnswers?.comment || ''}
        onSave={handleModalSave} // Ensure progress is loaded as 0 if not set
        goalID={requirement.id}
        group= {groupTitle}
        goal={groupgoal}
      />
    </div>
  );
};

 {/*</div><div className="collapsible">
      <div className="requirement-header">
        <span>{requirement.id} - {requirement.text}</span>
        <input
          type="number"
          value={percentage}
          onChange={handlePercentageChange}
          min="0"
          max="100"
        />
      </div>
    </div>*/}





//Copliot PopUp
const Modal = ({ isOpen, onClose, messages, isTyping, input, handleInputChange, sendMessage }) => {
  if (!isOpen) return null;

  return (
    <div className="AicontentPop">
      <div className="AIContainerBoxPop">
        <div className="AiheaderPop">
            <h1 className="AIh1">Confomity Analyse Co-Pilot</h1>
          </div>
        <div className="chatbot-containerPop">
          <div className="chat-messages">
            {messages.map((msg, idx) => (
              <div key={idx} className={`message ${msg.sender}`}>
                {msg.text}
              </div>
            ))}
            {isTyping && <div className="typing-indicator">Typing...</div>}
          </div>
          <div className="inputBox">
            <form onSubmit={sendMessage}>
              <input
                className="promptInput"
                type="text"
                value={input}
                onChange={handleInputChange}
                placeholder="Ask a question..."
              />
              <button className="aibutton" type="submit">
                <svg height="24" width="24" fill="#FFFFFF" viewBox="0 0 24 24" data-name="Layer 1" id="Layer_1" class="sparkle">
                  <path d="M10,21.236,6.755,14.745.264,11.5,6.755,8.255,10,1.764l3.245,6.491L19.736,11.5l-6.491,3.245ZM18,21l1.5,3L21,21l3-1.5L21,18l-1.5-3L18,18l-3,1.5ZM19.333,4.667,20.5,7l1.167-2.333L24,3.5,21.667,2.333,20.5,0,19.333,2.333,17,3.5Z"></path>
                </svg>
                <span className="aitext">Answer</span>
              </button>
            </form>
            <button className='closeButton' onClick={onClose}>Close</button>
          </div>
        </div>
        
      </div>
    </div>
  );
};






// Main Component
const AdminConformityAssessment = () => {

  const group1 = "Accountability"
  const group2 = "Transparency"
  const group3 = "Fairness "
  const group4 = "Reliability & Safety"
  const group5 = "Privacy & Security"
  const group6 = "Inclusiveness"
  const group7 = "Risk Management"
  const group8 = "Impact Assessment"
  const group9 = "Data Quality Processing Framework"

  const questions = [
    {
      groupTitle: group1,
      goals: [
        {
          goal: "Impact Assessment",
          PreGoal: "Goal A1:",
          requirements: [
            {
              id: "A1.1",
              text: "Assess the impact of the system on people, organizations, and society by completing an Impact Assessment early in the system’s development.",
              tags: ["Impact Assessment"],
            },
            {
              id: "A1.2",
              text: "Review the completed Impact Assessment with the reviewers identified according to your organization’s compliance process.",
              tags: ["Impact Assessment"],
            },
            {
              id: "A1.3",
              text: "Update and review the Impact Assessment at least annually.",
              tags: ["Impact Assessment"],
            },
          ],
        },
        {
          goal:'Oversight of significant adverse impacts',
          PreGoal: 'Goal A2:',
          description: 'AI systems are reviewed to identify systems that may have a significant adverse impact on people, organizations, and society, and additional oversight and requirements are applied to those systems.',
          appliesTo: 'All AI systems',
          requirements: [
              {
                  id:'A2.1',
                  text: 'Review defined Restricted Uses to determine whether the system meets the definition of any Restricted Use. If it does, document this in the Impact Assessment, and follow the requirements for the Restricted Use.',
                  tags: ['Impact Assessment']
              },
              {
                  id:'A2.2',
                  text: 'Answer prompts in the Impact Assessment template to determine whether the system meets the definition of a Sensitive Use. If it does, report it to the Office of Responsible AI, and follow any additional requirements resulting from a Sensitive Uses review.',
                  tags: ['Impact Assessment']
              },
              {
                  id:'A2.3',
                  text: 'Review your systems at least annually against the definitions for Sensitive Uses and Restricted Uses. If there are systems that meet the criteria for Sensitive Uses, report them to the Responsible person(s) and/or reporting authority. If there are systems that meet the criteria for Restricted Uses, notify the same Responsible person(s) and/or reporting authority.',
                  tags: ['Impact Assessment']
              },
          ]
        },
        {
          goal:'Fit for purpose',
          PreGoal: 'Goal A3:',
          description: 'AI systems are fit for purpose in the sense that they provide valid solutions for the problems they are designed to solve.',
          appliesTo: 'All AI systems',
          requirements: [
              {
                  id:'A3.1',
                  text: 'Document in the Impact Assessment how the system’s use will solve the problem posed by each intended use, recognizing that there may be multiple valid ways in which to solve the problem.',
                  tags: ['Impact Assessment']
              },
              {
                  id:'A3.2',
                  text: `Define and document for each model in the AI system:
                  <ol> 
                    <li>the model’s proposed inputs and how well they represent the concepts they are intended to represent; include analysis of the limitations of this representation, </li> 
                    <li>the model’s proposed output and how well it represents the concept it is intended to represent; include analysis of the limitations of this representation, and </li> 
                    <li>limitations to the generalizability of the resulting model based on the training and testing data that will be used.</li> </ol> `,
                
                  tags: null
              },
              {
                  id:'A3.3',
                  text: `Define and document Responsible Release Criteria for this Goal. Include:
                    <ol> 
                      <li>a concise definition of the problem being solved in the intended use,</li>
                      <li>performance metrics and their Responsible Release Criteria, and</li>
                      <li>error types and their Responsible Release Criteria.</li>
                    </ol> 
                    `,
                  
                  tags: null
              },
              {
                  id:'A3.4',
                  text: 'Document an evaluation plan for each of the performance metrics and error types.',
                  tags: ['Ongoing Evaluation Checkpoint.']
              },
              {
                  id:'A3.5',
                  text: 'Use the methods defined in requirement A3.4 to conduct evaluations. Document the pre-release results of the evaluations. Determine and document how often ongoing evaluation should be conducted to continue supporting this Goal.',
                  tags: ['Ongoing Evaluation Checkpoint.']
              },
              {
                  id:'A3.6',
                  text: `Provide documentation to customers which describes the system’s:
                  <ol>
                  <li>intended uses, and</li>
                  <li>evidence that the system is fit for purpose for each intended use.</li>
                  </ol>
                  When the system is a platform service made available to external customers or partners, include this information in the required Transparency Note.
                  `,
                  tags: ['Transparency Note.']
              },
              {
                  id:'A3.7',
                  text: `If an intended use is not supported by evidence, or if evidence comes to light that refutes that the system is fit for purpose for the intended use at any point in the system’s use:
                  <ol>
                  <li>remove the intended use from customer-facing materials and make current customers aware of the issue, take action to close the identified gap, or discontinue the system,</li>
                  <li>revise documentation related to the intended use, and</li>
                  <li>publish the revised documentation to customers.</li>
                  </ol>
                  When the system is a platform service made available to external customers or partners, include this information in the required Transparency Note.
                  `,
              },
              {
                  id:'A3.8',
                  text: 'Communicate with care about system benefits; follow any applicable guidance from your legal representatives.',
                  tags: null
              },

          ]
        },
        {
          goal: 'Data governance and management',
          PreGoal:'Goal A4:',
          description: 'AI systems are subject to appropriate data governance and management practices.',
          appliesTo: 'All AI systems',
          requirements: [
              {
                  id: 'A4.1',
                  text: 'Define and document data requirements with respect to the system’s intended uses, stakeholders, and the geographic areas where the system will be deployed. Document these requirements in the Impact Assessment. ',
                  tags: ['Impact Assessment']
              },
              {
                  id: 'A4.2',
                  text: 'Define and document procedures for the collection and processing of data, to include annotation, labelling, cleaning, enrichment, and aggregation, where relevant.',
                  tags: null
              },
              {
                  id: 'A4.3',
                  text: 'If you plan to use existing data sets to train the system, assess the quantity and suitability of available data sets that will be needed by the system in relation to the data requirements defined in A4.1. Document this assessment in the Impact Assessment.',
                  tags: ['Impact Assessment']
              },
              {
                  id: 'A4.4',
                  text: 'Define and document methods for evaluating data to be used by the system against the requirements defined in A4.1.',
                  tags: null
              },
              {
                  id: 'A4.5',
                  text: 'Evaluate all data sets using the methods defined in requirement A4.4. Document the results of the evaluation',
                  tags: null
              },
          ]
        },
        {
          goal: 'Human oversight and control',
          PreGoal:'Goal A5:',
          description: 'AI systems include capabilities that support informed human oversight and control.',
          appliesTo: 'All AI systems',
          requirements: [
              {
                  id: 'A5.1',
                  text: 'Identify the stakeholders who are responsible for troubleshooting, managing, operating, overseeing, and controlling the system during and after deployment. Document these stakeholders and their oversight and control responsibilities using the Impact Assessment template.',
                  tags: ['Impact Assessment']
              },
              {
                  id: 'A5.2',
                  text: `Identify the system elements (including system UX, features, alerting and reporting functions, and educational materials) necessary for stakeholders identified in requirement A5.1 to effectively understand their oversight responsibilities and carry them out. Stakeholders must be able to understand:
                  <ol>
                  <li>the system’s intended uses,</li>
                  <li>how to effectively execute interactions with the system,</li>
                  <li>how to interpret system behaviour,</li>
                  <li>when and how to override, intervene, or interrupt the system, and</li>
                  <li>how to remain aware of the possible tendency of over-relying on outputs produced by the system (“automation bias”).</li>
                  </ol>
                  Document the system design elements that will support relevant stakeholders for each oversight and control function.
                  `,
              },
              {
                  id: 'A5.3',
                  text: 'When possible, design the system elements identified in A5.2. When this is not possible (for example, when the organisation is not responsible for the system UX), provide guidance on human oversight considerations to the third party responsible for implementing the system elements identified in A5.2.',
                  tags: null
              },
              {
                  id: 'A5.4',
                  text: 'Define and document the method to be used to evaluate whether each oversight or control function can be accomplished by stakeholders in realistic conditions of system use. Include the metrics or rubrics that will be used in the evaluations. When this is not possible (for example, when the organisation is not responsible for oversight and control functions), provide guidance on evaluating oversight and control functions to the third party responsible for evaluating oversight or control functions.',
                  tags: null
              },
              {
                  id: 'A5.5',
                  text: 'Define and document Responsible Release Criteria to achieve this Goal.',
                  tags: null
              },
              {
                  id: 'A5.6',
                  text: 'Conduct evaluations defined by requirement A5.4 using a near-release version of the system. Document the results.',
                  tags: null
              },
              {
                  id: 'A5.7',
                  text: 'If there are Responsible Release Criteria for metrics or rubrics that have not been met, consult with the reviewers named in the Impact Assessment, and in the case of Sensitive Uses, with the Office of Responsible AI, to develop a plan detailing how the gap will be managed until it can be closed. Document that plan.',
                  tags: null
              },
          ]
        },
      ],
    },
    {
      groupTitle: group2,
      goals: [
        {
          goal: 'System intelligibility for decision making',
          PreGoal:'Goal T1:',
          description: 'AI systems that inform decision making by or about people are designed to support stakeholder needs for intelligibility of system behaviour.',
          appliesTo: 'All AI systems when the intended use of the generated outputs is to inform decision making by or about people.',
          requirements: [
              {
                  id: 'T1.1',
                  text: `Identify:
                  <ol>
                  <li>stakeholders who will use the outputs of the system to make decisions, and</li>
                  <li>stakeholders who are subject to decisions informed by the system. </li>
                  <li>Document these stakeholders using the Impact Assessment template. </li>
                  </ol>
                  `,
                  tags: ['Impact Assessment']
              },
              {
                  id: 'T1.2',
                  text: `Design the system, including, when possible, the system UX, features, reporting functions, and educational materials, so that stakeholders identified in requirement T1.1 can:
                  <ol>
                  <li>understand the system’s intended uses,</li>
                  <li>interpret relevant system behaviour effectively (i.e., in a way that supports informed decision making), and</li>
                  <li>remain aware of the possible tendency of over-relying on outputs produced by the system ("automation bias").</li>
                  </ol>
                  For the two categories of stakeholders identified in requirement T1.1, document:
                  <ol>
                  <li>how the system design will support their understanding of the system’s intended uses, and</li>
                  <li>how the system aids their ability to interpret relevant system responses, and</li>
                  <li>how the system design discourages automation bias.</li>
                  </ol>
                  `,
                  tags: ['Impact Assessment']
              },
              {
                  id: 'T1.3',
                  text: 'Define and document the method to be used to evaluate whether each stakeholder who will make decisions or be subject to decisions based on the behaviour of the system can interpret the relevant system responses reasonably well. Include the metrics or rubrics that will be used in the evaluations. ',
                  tags: ['Ongoing Evaluation Checkpoint.']
              },
              {
                  id: 'T1.4',
                  text: 'Define and document a Responsible Release Plan, to include Responsible Release Criteria to achieve this Goal.',
                  tags: ['Ongoing Evaluation Checkpoint.']
              },
              {
                  id: 'T1.5',
                  text: 'Conduct evaluations defined by requirement T1.3. Document the pre-release results of the evaluations. Determine and document how often ongoing evaluation should be conducted to continue supporting this Goal.',
                  tags: ['Ongoing Evaluation Checkpoint.']
              },
              {
                  id: 'T1.6',
                  text: 'If there are Responsible Release Criteria for metrics or rubrics that that have not been met, consult with the reviewers named in the Impact Assessment, and in the case of Sensitive Uses, with the responsible person(s), to develop a plan detailing how the gap will be managed until it can be closed. Document that plan.',
                  tags: null
              },
          ]
        },
        {
          goal: 'Communication to stakeholders',
          PreGoal:'Goal T2:',
          description: 'Provide information about the capabilities and limitations of AI systems to support stakeholders in making informed choices about those systems.',
          appliesTo: 'All AI systems.',
          requirements: [
              {
                  id: 'T2.1',
                  text: `Identify:
                  <ol>
                  <li>stakeholders who make decisions about whether to employ a system for particular tasks, and</li>
                  <li>stakeholders who develop or deploy systems that integrate with this system.</li>
                  </ol>
                  Document these stakeholders in the Impact Assessment template.
                  `,
                  tags: ['Impact Assessment']
              },
              {
                  id: 'T2.2',
                  text: `Publish documentation for the system so that stakeholders defined in T2.1 can understand the system.
                  Include:
                  <ol>
                  <li>capabilities,</li>
                  <li>intended uses,</li>
                  <li>uses that require extra care or guidance,</li>
                  <li>operational factors and settings that allow for effective and responsible system use</li>
                  <li>limitations, including uses for which the system was not designed or evaluated, and</li>
                  <li>evidence of system accuracy and performance as well as a description of the extent to which these results are generalizable across use cases that were not part of the evaluation.</li>
                  </ol>
                  When the system is a platform service made available to external customers or partners, a Transparency Note is required.
                  `,
                  tags: ['Transparency Note.']
              },
              {
                  id: 'T2.3',
                  text: `Review and update documentation annually or when any of the following events occur:
                  <ol>
                  <li>new uses are added,</li>
                  <li>functionality changes,</li>
                  <li>the product moves to a new release stage,</li>
                  <li>new information about reliable and safe performance becomes known as defined by requirement RS3.3, or</li>
                  <li>new information about system accuracy and performance becomes available.</li>
                  </ol>
                  When the system is a platform service made available to external customers or partners, include this information in the required Transparency Note.
                  `,
                  
                  text2: '',
                  tags: ['Transparency Note.']
              },
          ]
        },
        {
          goal: 'Disclosure of AI interaction',
          PreGoal:'Goal T3:',
          description: 'AI systems are designed to inform people that they are interacting with an AI system or are using a system that generates or manipulates image, audio, or video content that could falsely appear to be authentic.',
          appliesTo: 'AI systems that impersonate interactions with humans, unless it is obvious from the circumstances or context of use that an AI system is in use. AI systems that generate or manipulate image, audio, or video content that could falsely appear to be authentic.',
          requirements: [
              {
                  id: 'T3.1',
                  text: 'Identify stakeholders who will use or be exposed to the system, in accordance with the Impact Assessment requirements. Document these stakeholders using the Impact Assessment template. ',
                  tags: ['Impact Assessment']
              },
              {
                  id: 'T3.2',
                  text: 'Identify stakeholders who will use or be exposed to the system, in accordance with the Impact Assessment requirements. Document these stakeholders using the Impact Assessment template.',
                  tags: ['Impact Assessment.']
              },
              {
                  id: 'T3.3',
                  text: 'Design the system, including system UX, features, reporting functions, educational materials, and outputs so that stakeholders identified in T3.1 will be informed of the type of AI system they are interacting with or exposed to. Ensure that any image, audio, or video outputs that are intended to be used outside the system are labelled as being produced by AI.',
                  tags: null
              },
              {
                  id: 'T3.4',
                  text: 'Define and document the method to be used to evaluate whether each stakeholder identified in T3.1 is informed of the type of AI system they are interacting with or exposed to. ',
                  tags: ['Ongoing Evaluation Checkpoint.']
              },
              {
                  id: 'T3.5',
                  text: 'Define and document Responsible Release Criteria to achieve this Goal.',
                  tags: ['Ongoing Evaluation Checkpoint.']
              },
              {
                  id: 'T3.6',
                  text: 'Conduct evaluations defined by requirement T3.3. Document the pre-release results of the evaluations. Determine and document how often ongoing evaluation should be conducted to continue supporting this goal.',
                  tags: ['Ongoing Evaluation Checkpoint.']
              },
          ]
        },
      ]
    },
    {
      groupTitle: group3,
      goals: [
        {
          goal: 'Quality of service',
          PreGoal:'Goal F1:',
          description: 'AI systems are designed to provide a similar quality of service for identified demographic groups, including marginalized groups.',
          appliesTo: 'AI systems when system users or people impacted by the system with different demographic characteristics might experience differences in quality of service that the AI Systems developer(s) can remedy by building the system differently.',
          requirements: [
              {
                  id: 'F1.1',
                  text: `Identify and prioritize demographic groups, including marginalized groups, that may be at risk of experiencing worse quality of service based on intended uses and geographic areas where the system will be deployed. Include:
                  <ol>
                  <li>groups defined by a single factor, and</li>
                  <li>groups defined by a combination of factors.</li>
                  </ol>
                  Document the prioritized identified demographic groups using the Impact Assessment template.
                  `,
                  subRequirements: [
                      "",
                      "",
                  ],
                  text2: '',
                  tags: ['Impact Assessment']
              },
              {
                  id: 'F1.2',
                  text: 'Evaluate all data sets to assess inclusiveness of identified demographic groups and collect data to close gaps. Document this process and its results.',
                  tags: null
              },
              {
                  id: 'F1.3',
                  text: `Define and document the evaluation that you will perform to support this Goal. Include:
                  <ol>
                  <li>any system components to be evaluated, in addition to the whole system,</li>
                  <li>the metrics to be used to evaluate the system components and the whole system, and</li>
                  <li>a description of the data set to be used for this evaluation.</li>
                  </ol>
                  `,
                  subRequirements: [
                      "",
                      "",
                      "",
                  ],
                  tags: ['Ongoing Evaluation Checkpoint.']
              },
              {
                  id: 'F1.4',
                  text: `Define and document Responsible Release Criteria to achieve this Goal, as follows: For each metric, document:
                  <ol>
                  <li>any target minimum performance level for all groups, and</li>
                  <li>the target maximum (absolute or relative) performance difference between groups.</li>
                  </ol>
                  `,
                  subRequirements: [
                      "",
                      "",
                  ],
                  tags: ['Ongoing Evaluation Checkpoint.']
              },
              {
                  id: 'F1.5',
                  text: 'Evaluate the system according to the defined Responsible Release Criteria.',
                  tags: ['Ongoing Evaluation Checkpoint.']
              },
              {
                  id: 'F1.6',
                  text: `Identify and document any justifiable factors, such as circumstantial and other operational factors (e.g., “background noise” for speech recognition systems or “image resolution” for facial recognition systems), that account for:
                  <ol>
                  <li>any inability to meet any target minimum performance level for any identified demographic group, and</li>
                  <li>any remaining performance differences between identified demographic groups.</li>
                  </ol>
                  `,
                  subRequirements: [
                      "",
                      "",
                  ],
                  tags: ['Ongoing Evaluation Checkpoint.']
              },
              {
                  id: 'F1.7',
                  text: 'Document the pre-release results from requirements F1.4, F1.5, and F1.6. Determine and document how often ongoing evaluation should be conducted to continue supporting this Goal.',
                  tags: ['Ongoing Evaluation Checkpoint.']
              },
              {
                  id: 'F1.8',
                  text: `Publish information for customers about:
                  <ol>
                  <li>identified demographic groups for which performance may not meet any target minimum performance level,</li>
                  <li>any remaining performance disparities between identified demographic groups that may exceed the target maximum, and</li>
                  <li>any justifiable factors that account for these performance levels and differences.</li>
                  </ol>
                  When the system is a platform service made available to external customers or partners, include this information in the required Transparency Note.
                  `,
                  subRequirements: [
                      "",
                      "",
                      "",
                  ],
                  text2: '',
                  tags:['Transparency Note.']
              },
          ]
        },
        {
          goal: 'Allocation of resources and opportunities',
          PreGoal:'Goal F2:',
          description: 'AI systems that allocate resources or opportunities in essential domains are designed to do so in a manner that minimizes disparities in outcomes for identified demographic groups, including marginalized groups.',
          appliesTo: 'AI systems that generate outputs that directly affect the allocation of resources or opportunities relating to finance, education, employment, healthcare, housing, insurance, or social welfare.',
          requirements: [
              {
                  id: 'F2.1',
                  text: `Identify and prioritize demographic groups, including marginalized groups, that may be at risk of being differentially impacted by the system based on intended uses and geographic areas where the system will be deployed. Include:
                  <ol>
                  <li>groups defined by a single factor, and</li>
                  <li>groups defined by a combination of factors.</li>
                  </ol>
                  Document the prioritized identified demographic groups using the Impact Assessment template.
                  `,
                  tags: ['Impact Assessment']
              },
              {
                  id: 'F2.2',
                  text: 'Evaluate all data sets to assess inclusiveness of identified demographic groups and collect data to close any gaps. Document this process and its results.',
              },
              {
                  id: 'F2.3',
                  text: `Define and document the evaluation that you will perform to support this Goal. Include:
                  <ol>
                  <li>any system components to be evaluated, in addition to the whole system,</li>
                  <li>the metrics to be used to evaluate the system components and the whole system, and</li>
                  <li>the data set to be used for this evaluation.</li>
                  </ol>
                  `,
                  subRequirements: [
                      "",	
                      "",
                      "",
                  ],
                  tags: ['Ongoing Evaluation Checkpoint.']
              },
              {
                  id: 'F2.4',
                  text: 'Define and document Responsible Release Criteria to achieve this Goal, as follows: For each metric, document the target maximum difference (absolute or relative) between the rates at which resources and opportunities are allocated to groups.',
                  tags: ['Ongoing Evaluation Checkpoint.']
              },
              {
                  id: 'F2.5',
                  text: 'Evaluate the system according to the defined Responsible Release Criteria.',
                  tags: ['Ongoing Evaluation Checkpoint.']
              },
              {
                  id: 'F2.6',
                  text: 'Reassess the system design, including the choice of training data, features, objective function, and training algorithm, to pursue the goal of minimizing differences between the rates at which resources and opportunities are allocated to identified demographic groups, paying particular attention to those that exceed the target maximum difference, while recognizing that doing so may appear to affect system performance and it is seldom clear how to make such trade-offs. </br> Consult with your legal representative to determine your approach to this, including how you will identify and document trade-offs.',
                  text3: '',
                  tags: ['Ongoing Evaluation Checkpoint.']
              },
              {
                  id: 'F2.7',
                  text: 'Identify and document any justifiable factors that account for any remaining differences between the    rates at which resources and opportunities are allocated to identified demographic groups.',
                  tags: ['Ongoing Evaluation Checkpoint.']
              },
              {
                  id: 'F2.8',
                  text: 'Document the pre-release results for the evaluation described by requirements F2.4, F2.5, and F2.6.Determine and document how often ongoing evaluation should be conducted to continue supporting this goal.',
                  tags: ['Ongoing Evaluation Checkpoint.']
              },
              {
                  id: 'F2.9',
                  text: 'Publish information for customers about: any remaining differences between the rates at which resources and opportunities are allocated to identified demographic groups, and any justifiable factors that account for these differences. When the system is a platform service made available to external customers or partners, include this information in the required Transparency Note.',
                  tags: ['Transparency Note.']
              },
          ]
        },
        {
          goal: 'Minimization of stereotyping, demeaning, and erasing outputs',
          PreGoal:'Goal F3:',
          description: 'AI systems that describe, depict, or otherwise represent people, cultures, or society are designed to minimize the potential for stereotyping, demeaning, or erasing identified demographic groups, including marginalized groups.',
          appliesTo: 'AI systems when system outputs include descriptions, depictions, or other representations of people, cultures, or society.',
          requirements: [
              {
                  id: 'F3.1',
                  text: `Identify and prioritize demographic groups, including marginalized groups, that may be at risk of being subject to stereotyping, demeaning, or erasing outputs of the system. Include:
                  <ol>
                  <li>groups defined by a single factor, and</li>
                  <li>groups defined by a combination of factors.</li>
                  </ol>
                  Document the prioritized identified demographic groups using the Impact Assessment template.
                  `,
                  tags: ['Impact Assessment']
              },
              {
                  id: 'F3.2',
                  text: 'Define and document any system components to be evaluated, in addition to the whole system.',
                  tags: ['Impact Assessment.']
              },
              {
                  id: 'F3.3',
                  text: 'Define and document a plan to evaluate the system components and the whole system for risks of stereotyping, demeaning, and erasing the prioritized identified demographic groups. ',
                  tags: ['Ongoing Evaluation Checkpoint.']
              },
              {
                  id: 'F3.4',
                  text: 'Evaluate the system according to the plan defined in requirement F3.3.',
                  tags: ['Ongoing Evaluation Checkpoint.']
              },
              {
                  id: 'F3.5',
                  text: 'Reassess the system design, including the choice of training data, features, objective function, and training algorithm, to pursue the goal of minimizing the potential for stereotyping, demeaning, and erasing the identified demographic groups.',
                  tags: ['Ongoing Evaluation Checkpoint.']
              },
              {
                  id: 'F3.6',
                  text: 'Document the pre-release results from requirements F3.4 and F3.5. Determine and document how often ongoing evaluation should be conducted to continue supporting this goal. ',
                  tags: ['Ongoing Evaluation Checkpoint.']
              },
              {
                  id: 'F3.7',
                  text: 'Publish information for customers about these risks involving identified demographic groups. When the system is a platform service made available to external customers or partners, include this information in the required Transparency Note.',
                  tags: ['Ongoing Evaluation Checkpoint.']
              },
          ]
        },
      ]
    },
    {
      groupTitle: group4,
      goals: [
        {
          goal: 'Reliability and safety guidance',
          PreGoal:'Goal RS1:',
          description: 'Evaluate the operational factors and ranges within which AI systems are expected to perform reliably and safely, remediates issues, and provide related information to customers.',
          appliesTo: 'All AI systems.',
          requirements: [
              {
                  id: 'RS1.1',
                  text: `Document how:
                  <ol>
                  <li>reliable and safe behaviour is defined for this system and,</li>
                  <li>what acceptable error rates are for overall system performance in the context of intended uses.</li>
                  </ol>
                  `,
                  subRequirements: [
                      "",
                      "",
                  ],
                  tags: ['Ongoing Evaluation Checkpoint.']
              },
              {
                  id: 'RS1.2',
                  text: 'Evaluate training and test data sets to ensure that they include representation of the intended uses, operational factors, and an appropriate range of settings for each factor. Document the evaluation.',
                  tags: null
              },
              {
                  id: 'RS1.3',
                  text: 'Determine and document the operational factors, including quality of system input, use, and operational context that are critical to manage for reliable and safe use of the system in its deployed context.',
                  tags: ['Ongoing Evaluation Checkpoint.']
              },
              {
                  id: 'RS1.4',
                  text: 'Define and document acceptable ranges for each operational factor important to support reliable and safe system use. Define and document an acceptable error rate for the system when operating within these ranges.',
                  tags: ['Ongoing Evaluation Checkpoint.']
              },
              {
                  id: 'RS1.5',
                  text: 'Define intended uses, if any, where additional operational factors, more narrow or different acceptable ranges, or lower acceptable error rates (including false positive and false negative error rates), are advised to ensure reliability and safety. Document your conclusions.',
                  tags: ['Ongoing Evaluation Checkpoint.']
              },
              {
                  id: 'RS1.6',
                  text: 'Define and document an evaluation plan based on requirements RS1.1, RS1.3, RS1.4, and RS1.5, to include the environment in which the system will be evaluated.',
                  tags: ['Ongoing Evaluation Checkpoint.']
              },
              {
                  id: 'RS1.7',
                  text: 'Evaluate the system according to the evaluation plan defined in requirement RS1.6 to ensure reliable and safe system behaviour. Document the pre-release results of the evaluation. Determine and document how often ongoing evaluation should be conducted to continue supporting this goal.',
                  tags: ['Ongoing Evaluation Checkpoint.']
              },
              {
                  id: 'RS1.8',
                  text: 'In the event of failure cases within operational factors and defined ranges, work to resolve the issues. If the Responsible Release Criteria established in requirements RS1.1, RS1.3, RS1.4, and RS1.5 cannot be met, a reassessment of intended uses and updated documentation is required.',
                  tags:['Ongoing Evaluation Checkpoint.']
              },
              {
                  id: 'RS1.9',
                  text: 'Provide documentation to customers and potential customers of the system that includes the outputs of requirements RS1.2, RS1.7 and RS1.8, and any unsupported uses defined in the Impact Assessment and in RS1.8. When the system is a platform service made available to external customers or partners, include this information in the required Transparency Note.',
                  tags:['Impact Assessment','Transparency Note.']
              },
          ]
        },
        {
          goal: 'Failures and remediations',
          PreGoal:'Goal RS2:',
          description: 'AI systems are designed to minimize the time to remediation of predictable or known failures.',
          appliesTo: 'All AI systems.',
          requirements: [
              {
                  id: 'RS2.1',
                  text: 'Define predictable failures, including false positive and false negative results for the system as a whole and how they would impact stakeholders for each intended use. Use the Impact Assessment template to document any adverse impacts of these failures on stakeholders.',
                  tags: ['Impact Assessment']
              },
              {
                  id: 'RS2.2',
                  text: `For each case of a predictable failure likely to have an adverse impact on a stakeholder, document the failure management approach:
                  <ol>
                  <li>When possible, design and build the system to avoid this failure. Describe the design solution. Estimate the time range for resolving predictable failures for each designed solution or indicate that the failure will be prevented by design.</li>
                  <li>When a failure cannot be prevented by design, build a fallback option that may be used when this failure occurs. Describe the fallback option and document the estimated time required to invoke and use the fallback option.</li>
                  <li>Provide training and documentation for stakeholders accountable for system oversight that supports their resolution of the failure. Describe the documentation and training.</li>
                  </ol>
                  `,
                  subRequirements: [
                      "",	
                      "",
                      "",
                  ],
                  tags: null
              },
              {
                  id: 'RS2.3',
                  text: `Document your plan for managing previously unknown failures that come to light once the system is in use:
                  <ol>
                  <li>Describe the system’s rollback plan and document the time that may elapse until the entire system, across all endpoints can be rolled back.</li>
                  <li>Describe support for turning features off and document the time that may elapse until the feature can be turned off across all endpoints.</li>
                  <li>Describe the process for updating and releasing updates to each model and document the time that may elapse until the system has been updated across all endpoints.</li>
                  <li>Describe how customers, partners, and end users will be notified of changes to the system, updated understandings of failures, and their best mitigations.</li>
                  </ol>
                  `,
                  subRequirements: [
                      "",	
                      "",
                      "",
                      "",
                  ],
                  tags: null
              },
              {
                  id: 'RS2.4',
                  text: 'Provide training and documentation for system owners, developers, customer support and other stakeholders responsible for managing the system to support their remediation and mitigation of predictable failures identified in requirement RS2.1. Document the training and documentation provided.',
                  tags: null
              },
              
          ]
        },
        {
          goal: 'Ongoing monitoring, feedback, and evaluation',
          PreGoal:'Goal RS3:',
          description: 'AI systems are subject to ongoing monitoring, feedback, and evaluation so that we can identify and review new uses, identify and troubleshoot issues, manage and maintain the systems, and improve them over time.',
          appliesTo: 'All AI systems.',
          requirements: [
              {
                  id: 'RS3.1',
                  text: `Establish and document a detailed inventory of the system health monitoring methods to be used, to include:
                  <ol>
                  <li>data and insights generated from data repositories, system analytics, and associated alerts,</li>
                  <li>processes by which customers can submit information about failures and concerns, and</li>
                  <li>processes by which the general public can submit feedback.</li>
                  </ol>
                  `,
                  subRequirements: [
                      "",
                      "",
                      "",
                  ],
                  tags: null
              },
              {
                  id: 'RS3.2',
                  text: `Define and document a standard operating procedure and system health monitoring action plan for each monitoring channel for the system, to include:
                  <ol>
                  <li>processes for reproducing system failures to support troubleshooting and prevention of future failures,</li>
                  <li>which events will be monitored,</li>
                  <li>how events will be prioritized for review,</li>
                  <li>the expected frequency of those reviews,</li>
                  <li>how events will be prioritized for response and timing to resolution,</li>
                  <li>how high priority issues related to supporting the Standard and its goals will be escalated to the responsible person(s), and</li>
                  <li>engaging customer service to ensure that they are aware of how to respond to issues for the system.</li>
                  </ol>
                  `,
                  subRequirements: [
                      "",
                      "",
                      "",
                      "",
                      "",
                      "",
                      "",
                  ],
                  tags: null
              },
              {
                  id: 'RS3.3',
                  text: `When new uses, critical operational factors, or changes in the supported range of an operational factor are identified, determine whether any new use or operational factor can be supported with the existing system, will be supported but require additional work, or will not be supported.
                  <ol>
                  <li>When new uses or operational factors identified are to be supported, evaluate the updated system in accordance with requirement RS1.6, add the new intended use to the Impact Assessment, and publish updated communication in accordance with requirement RS1.9.</li>
                  <li>When these new uses or operational factor range changes cannot or will not be accommodated to ensure reliable and safe performance of the system update customer documentation described in RS1.9 to includethe new use as an unsupported use.</li>
                  </ol>
                  When the system is a platform service made available to external customers or partners, include this information in the required Transparency Note.
                  `,
                  subRequirements2: [
                      "",
                      "",
                  ],
                  text2: '',
                  tags: ['Impact Assessment', 'Transparency Note']
              },
              {
                  id: 'RS3.4',
                  text: 'When a system is to be used for a Sensitive Use that imposes qualification or quality control requirements beyond the intended uses and/or operational factor ranges, conduct an evaluation specific to this use. If the required Responsible Release Criteria cannot be met, the responsible person (sI should review the results and decide how to proceed. Document any changes to the Responsible Release Criteria and document the results of evaluation.',
                  tags: null
              },
              {
                  id: 'RS3.5',
                  text: 'Conduct all evaluations tagged as Ongoing Evaluation Checkpoints in other Goals on an ongoing basis.',
                  tags: null
              },
              {
                  id: 'RS3.6',
                  text: 'If there are targets in Ongoing Evaluation Checkpoints that are no longer satisfied, consult with named reviewers, and in the case of Sensitive Uses, with the responsible person(s), to develop and implement a plan to close any gaps. Document the process, its results, and conclusions.',
                  tags: null
              },
              {
                  id: 'RS3.7',
                  text: `If evidence comes to light that refutes the system is fit for purpose for an intended use at any point in the system’s use:
                  <ol>
                  <li>remove the intended use from customer-facing materials and make current customers aware of the issue, take action to close the identified gap, or discontinue the system,</li>
                  <li>revise documentation related to the intended use, and</li>
                  <li>publish the revised documentation to customers.</li>
                  When the system is a platform service made available to external customers or partners, include this information in the required Transparency Note.
                  `,
                  subRequirements: [
                      "",
                      "",
                      "",
                  ],
                  text2: '',
                  tags: ['Transparency Note.']
              },
              {
                  id: 'RS3.8',
                  text: `Review and update documentation required by Goal T2 when any of the following events occur:
                  <ol>
                  <li>functionality changes,</li>
                  <li>new information about reliable and safe performance becomes known as defined by requirement RS3.3, or</li>
                  <li>new information about system accuracy and performance becomes available.</li>
                  <li>new uses are added,</li>
                  </ol>
                  When the system is a platform service made available to external customers or partners, include this information in the required Transparency Note.
                  `,
                  subRequirements: [
                      "",
                      "",
                      "",
                      "",
                  ],
                  text2: '',
                  tags: ['Transparency Note.']
              },
              {
                  id: 'RS3.9',
                  text: 'Escalate unresolved issues related to supporting the Standard and its requirements to the responsible person(s).',
                  tags: null
              },
          ]
        },
      ]
    },
    {
      groupTitle: group5,
      goals: [
        {
          goal: 'Privacy Standard compliance',
          PreGoal:'Goal PS1:',
          description: 'AI systems are designed to protect privacy in accordance with the legal and regulatory requirements of the geographic jurisdictions within which they are deployed and within the geographic jurisdictions from which training, testing and validation data has been sourced. Additionally, they should follow international standards and aim to meet potential customer criteria (normally based on the legal and regulatory requirements and national and international standards). The main privacy goals to be built into AI systems are outlined below, along with details on how they are used:',
          appliesTo: 'Legal and Regulatory requirements are present and/or where the customer has specific criteria set out in a privacy policy (and supporting procedures)',
          requirements: [
              {
                  id: 'PS1.1',
                  text: 'Data Minimization: Minimize the collection, storage, and processing of personal data to the extent necessary for achieving the intended purpose. </br> AI systems should only collect and retain the minimum amount of data required to fulfil their functions, reducing the risk of privacy breaches and limiting exposure to potential misuse.',
                  
              },
              {
                  id: 'PS1.2',
                  text: 'Purpose Limitation: Limit the use of personal data to specific, legitimate purposes disclosed to the data subjects at the time of collection. </br> AI systems should process personal data only for the purposes for which it was collected or consented to by the individuals, ensuring transparency and accountability in data processing activities.',
                  text2: ''
                  
              },
              {
                  id: 'PS1.3',
                  text: `Data Accuracy and Integrity: Ensure the accuracy, completeness, and integrity of personal data processed by AI systems. </br> AI systems should employ measures to maintain data accuracy and integrity, such as data validation, verification, and correction mechanisms, to prevent inaccuracies and errors that could impact individuals' rights and interests.`,
                  text2: ""
                  
              },
              {
                  id: 'PS1.4',
                  text: 'User Consent and Control: Obtain informed consent from individuals for the collection, use, and sharing of their personal data and provide them with control over their data. </br> AI systems should incorporate mechanisms for obtaining explicit consent from users for data processing activities and offer options for users to manage their privacy preferences, access, rectify, or delete their data.',
                  text2: ''
                  
              },
              {
                  id: 'PS1.5',
                  text: 'Transparency and Accountability: Ensure transparency in AI system operations, decision-making processes, and data processing activities, and establish accountability for compliance with privacy laws and regulations. </br> AI systems should provide users with clear and accessible information about how their data is collected, used, and shared, as well as the purposes and implications of AI-driven decisions. Organizations should implement measures to monitor, audit, and demonstrate compliance with privacy requirements, fostering trust and accountability.',
                  text2: ''
                  
              },
              {
                  id: 'PS1.6',
                  text: 'Security Safeguards: Implement robust security measures to protect personal data against unauthorized access, disclosure, alteration, or destruction. </br> AI systems should incorporate security safeguards, such as encryption, access controls, authentication mechanisms, and regular security assessments, to safeguard personal data from cyber threats, data breaches, and unauthorized use.',
                  text2: ''
                  
              },
              {
                  id: 'PS1.7',
                  text: `Fairness and Non-discrimination: Ensure that AI systems do not perpetuate biases, discrimination, or unfair treatment against individuals or groups based on protected characteristics. </br> AI systems should be designed, trained, and evaluated to mitigate biases and ensure fairness in decision-making processes, such as algorithmic assessments, recommendations, and predictions, to promote equal treatment and non-discrimination.`,
                  text2: ''
                  
              },
              {
                  id: 'PS1.8',
                  text: 'Data Subject Rights: Respect and facilitate the exercise of data subject rights, including the right to access, rectify, erase, and restrict the processing of personal data. </br> AI systems should provide mechanisms for individuals to exercise their data rights effectively, such as user-friendly interfaces for data access requests, data portability, and consent management, enabling individuals to assert control over their personal data.',
                  text2: ''
                  
              },
          ]
        },
        {
          goal: 'Security Policy compliance',
          PreGoal:'Goal PS2:',
          description: 'AI systems are designed to be secure in accordance with legal and regulatory requirements alongside any requirements set out by the customer.',
          appliesTo: 'Legal and Regulatory requirements are present and/or the Customer has a defined set of security requirements or standard that must be followed',
          text3: 'Overall Security Requirements should be focussed on:',
          requirements: [
              {
                
                  id:`PS2.1`,
                  text: `Data Security:
                  <ol>
                  <li>Data Encryption: Encrypt sensitive data at rest and in transit to prevent unauthorized access.</li>
                  <li>Access Controls: Implement access controls to restrict data access to authorized users and roles.</li>
                  <li>Data Minimization: Minimize the collection and retention of sensitive data to reduce the attack surface.</li>
                  <li>Data Integrity: Ensure the integrity of data by implementing measures to detect and prevent data tampering.</li>
                  </ol>
                  `,
                  subRequirements2: [
                      "",
                      "",
                      "",
                      "",
                  ],
                  
              },
              {
                  id:`PS2.2` ,
                  text:`Model Security:
                  <ol>
                  <li>Model Encryption: Encrypt trained models to protect intellectual property and prevent model theft.</li>
                  <li>Model Versioning: Maintain version control of models to track changes and ensure reproducibility.</li>
                  <li>Model Validation: Validate models for accuracy, fairness, and robustness to mitigate risks of biased or inaccurate predictions.</li>
                  <li>Model Auditing: Conduct regular audits of models to detect and mitigate vulnerabilities and ensure compliance with security standards.</li>
                  </ol>
                  `,
                  subRequirements2: [
                      "",
                      "",
                      "",
                      "",
                  ],
                  
              },
              {
                  id:`PS2.3` ,
                  text:`Access Control and Authentication:
                  <ol>
                  <li>User Authentication: Implement strong authentication mechanisms, such as multi-factor authentication (MFA), to verify the identities of users.</li>
                  <li>Role-based Access Control (RBAC): Assign roles and permissions to users based on their responsibilities and privileges.</li>
                  <li>API Security: Secure APIs used for accessing and interacting with AI systems through authentication, authorization, and encryption.</li>
                  <li>Session Management: Manage user sessions securely to prevent session hijacking and unauthorized access.</li>
                  </ol>
                  `,
                  subRequirements2: [
                      "",
                      "",
                      "",
                      "",
                  ],
                  
              },
              {
                  id:`PS2.4` ,
                  text:`Network Security:
                  <ol>
                  <li>Firewalls and Intrusion Detection Systems (IDS): Deploy firewalls and IDS to monitor and control network traffic and detect suspicious activities.</li>
                  <li>Secure Communication Protocols: Use secure communication protocols (e.g., HTTPS, SSL/TLS) to protect data transmission between AI systems and other components.</li>
                  <li>Network Segmentation: Segment networks to isolate AI systems from other systems and restrict communication to authorized entities.</li>
                  </ol>
                  `,
                  subRequirements2: [
                      "",
                      "",
                      "",
                  ],
                  
              },
              {
                  id:`PS2.5` ,
                  text:`System and Software Security:
                  <ol>
                  <li>Secure Coding Practices: Follow secure coding practices to mitigate common vulnerabilities, such as buffer overflows and injection attacks.</li>
                  <li>Patch Management: Keep AI system software and dependencies up to date with security patches to address known vulnerabilities.</li>
                  <li>Vulnerability Scanning and Penetration Testing: Conduct regular vulnerability assessments and penetration testing to identify and remediate security weaknesses.</li>
                  <li>Secure Configuration Management: Configure AI systems securely, disabling unnecessary services and applying least privilege principles.</li>
                  </ol>
                  `,
                  subRequirements2: [
                      "",
                      "",
                      "",
                      "",
                  ],
                  
              },
              {
                  id:`PS2.6` ,
                  text:`Incident Response and Recovery:
                  <ol>
                  <li>Incident Response Plan: Develop an incident response plan outlining procedures for detecting, responding to, and recovering from security incidents.</li>
                  <li>Logging and Monitoring: Implement logging and monitoring mechanisms to track system activities, detect anomalies, and investigate security incidents.</li>
                  <li>Backup and Disaster Recovery: Establish backup and disaster recovery processes to ensure data integrity and system availability in the event of a security breach or system failure.</li>
                  </ol>
                  `,
                  subRequirements2: [
                      "",
                      "",
                      "",
                  ],
                  
              },
              {
                  id:`PS2.7` ,
                  text:`Regulatory Compliance:
                  <ol>
                  <li>Data Protection Regulations: Ensure compliance with data protection regulations (e.g., GDPR, CCPA) by implementing appropriate security measures for protecting personal data processed by AI systems.</li>
                  <li>Industry Standards: Adhere to industry-specific security standards and best practices relevant to AI systems (e.g., NIST, ISO/IEC 27001) to demonstrate due diligence and compliance.</li>
                  </ol>
                  `,
                  subRequirements2: [
                      "",
                      "",

                  ],
                  
              },
          ]
        },
      ]
    },
    {
      groupTitle: group6,
      goals: [
        {
          goal: 'Accessibility Standards compliance',
          PreGoal:'Goal I1:',
          description: 'AI systems are designed to be inclusive in accordance with any Accessibility Standards.',
          appliesTo: 'Where Accessibility Standards apply.',
          text2: 'Designing inclusive AI systems that adhere to accessibility standards requires a multi-faceted approach, encompassing considerations throughout the entire development lifecycle:',
          requirements: [
              {
                  id: 'I1.1',
                  text: `Adherence to Accessibility Standards & Guidelines- WCAG (Web Content Accessibility Guidelines): These are the internationally recognized standards for web accessibility, ensuring content is perceivable, operable, understandable, and robust for people with disabilities. AI systems interacting with web content must comply with these guidelines. <br/> EAA (European Accessibility Act): This EU legislation establishes accessibility requirements for various products and services, though it doesn't directly address AI systems yet. However, its principles can and should be applied to AI design. <br/> Other Relevant Standards: Depending on the specific application and context, other accessibility standards may apply, such as Section 508 in the US for federal agencies.`, 
              },
              {
                  id: 'I1.2',
                  text: 'Inclusive Design Principles: Recognize Exclusion: Identify potential barriers for users with diverse abilities, backgrounds, and contexts. </br> Solve for One, Extend to Many: Design solutions that address specific needs but also benefit a wider range of users. Learn from Diversity: Involve people with disabilities in the design and testing process to gain valuable insights and feedback.',
                  s2: "",
                  
              },
              {
                  id: 'I1.3',
                  text: 'Technical Implementation: Multi-modal Interactions: Offer multiple ways for users to interact with the AI system, including voice commands, text input, and gesture recognition. </br> Alternative Text and Descriptions: Provide descriptive text alternatives for images, videos, and other non-text content. </br> Keyboard Accessibility: Ensure that all functionalities of the AI system can be accessed and operated using a keyboard. </br> Clear and Simple Language: Use plain language that is easy to understand, avoiding jargon or complex terminology. Error Handling and Feedback: Provide clear and helpful error messages and feedback to guide users through any difficulties. </br> Customization and Personalization: Allow users to adjust settings, such as font size, colour contrast, or speech rate, to meet their individual needs and preferences. ',
                  s2: "   ",
                  s3: '',
                  s4: '.',
                  s5: '  '
                  
              },
              {
                  id: 'I1.4',
                  text: `Testing and Evaluation: Accessibility Testing: Conduct thorough testing with users with disabilities to identify and address any barriers. Assistive Technology Compatibility: Ensure that the AI system is compatible with assistive technologies such as screen readers, magnifiers, and alternative input devices. </br> Usability Testing: Evaluate the system's overall usability and ease of use for diverse users.`,
                  s2: "",
                  s3: null
                  
              },
              {
                  id: 'I1.5',
                  text: 'Ongoing Monitoring and Improvement: Collect User Feedback: Continuously gather feedback from users with disabilities to identify areas for improvement. </br> Stay Up-to-Date: Keep abreast of the latest developments in accessibility standards and technologies. </br> Iterate and Improve: Regularly update and refine the AI system to enhance its accessibility and inclusivity.',
              },

          ]
        },
      ]
    },
    {
      groupTitle: group7,
      goals: [
        {
          goal: 'Risk Management Standards compliance (ISO 31000: 2018 and ISO/IEC 23894:2023)',
          PreGoal:'Goal RM1:',
          requirements: [
              {
                  id: 'RM1.1',
                  text: 'A structured and comprehensive approach to risk management',
              },
              {
                id: 'RM1.2',
                text: 'The risk management framework and process are customized and proportionate to the organization’s external and internal context related to its objectives.',
              },
              {
                id: 'RM1.3',
                text: 'Appropriate and timely involvement of stakeholders',
              },
              {
                id: 'RM1.4',
                text: 'Anticipates, detects, acknowledges and responds to new risks and events in an appropriate and timely manner.',
              },
              {
                id: 'RM1.5',
                text: 'Risk Management is based on historical and current information and  any limitations and uncertainties associated with this information are taken into account',
              },
              {
                id: 'RM1.6',
                text: 'Human behaviour and culture are taken into account for risk management at each level and stage.',
              },
              {
                id: 'RM1.7',
                text: 'Risk management is continually improved through learning and experience.',
              },
          ]
        }
      ]
    },
    {
      groupTitle: group8,
      goals: [
        {
          goal: 'To proactively identify and mitigate potential risks and negative impacts on individuals, groups, and society while maximizing the benefits of AI technology.',
          PreGoal:'Goal IA1:',
          requirements: [
              {
                  id: 'IA1.1',
                  text: 'Data: Assess the quality, relevance, and representativeness of the data used to train and operate the AI system. Identify potential biases and address them through appropriate data cleaning, pre-processing, or algorithmic adjustments.',
              },
              {
                id: 'IA1.2',
                text: ` Algorithm: Analyse the algorithm's design and implementation, ensuring that it is transparent, explainable, and auditable. Assess the potential for unintended consequences or biases in the algorithm's decision-making processes.`,
              },
              {
                id: 'IA1.3',
                text: `Human-AI Interaction: Evaluate how humans interact with the AI system. Consider factors such as user interface design, transparency of the system's actions, and mechanisms for user feedback and control.`,
              },
              {
                id: 'IA1.4',
                text: 'Impact on Individuals and Society: Assess the potential impact of the AI system on individuals, groups, and society as a whole. Consider both positive and negative impacts, including potential discriminatory outcomes, social and economic effects, and ethical implications.',
              },
              {
                id: 'IA1.5',
                text: `Monitoring and Evaluation: Establish mechanisms for ongoing monitoring and evaluation of the AI system's performance and impact. Regularly assess the system's effectiveness, identify potential issues, and implement necessary changes or updates.`,
              },
              {
                id: 'IA1.6',
                text: `  Governance and Accountability: Develop governance structures and processes to ensure responsible AI development and deployment. Clearly define roles and responsibilities, establish mechanisms for oversight and accountability, and create channels for feedback and redress.`,
              },
              {
                id: 'IA1.7',
                text: ` Legal and Regulatory Compliance: Ensure that the AI system complies with relevant laws and regulations, such as data protection laws, anti-discrimination laws, and sector-specific regulations.`,
              },
              {
                id: 'IA1.8',
                text: `Ethical Considerations: Reflect on the ethical implications of the AI system, considering issues such as fairness, transparency, autonomy, and human dignity. Consult with ethicists and other stakeholders to ensure ethical decision-making throughout the development and deployment process.`,
              },
              {
                id: 'IA1.9',
                text: `Stakeholder Engagement: Engage with relevant stakeholders, including users, affected communities, and experts, to gather diverse perspectives and address concerns related to the AI system's impact.`,
              },
          ]
        }
      ]
    },
    {
      groupTitle: group9,
      goals: [
        {
          goal: 'Within the context of AI, the overall goal of a data quality processing framework is to ensure that the data used for training, testing, and deploying AI models is of the highest quality. This is critical because the performance, accuracy, and fairness of AI models are directly dependent on the quality of the input data.',
          PreGoal:'Goal DQ1:',
          description: 'AI systems are designed to be inclusive in accordance with any Accessibility Standards.',
          text2: 'Designing inclusive AI systems that adhere to accessibility standards requires a multi-faceted approach, encompassing considerations throughout the entire development lifecycle:',
          requirements: [
              {
                  id: 'DQ1.1',
                  text: 'Data Quality Dimensions: The framework defines key dimensions of data quality such as accuracy, completeness, consistency, timeliness, and relevance. These dimensions help organizations assess and monitor the quality of their data across different use cases.',
              }, 
              {
                  id: 'DQ1.2',
                  text: 'Data Quality Requirements: Organizations must establish clear data quality requirements that align with business needs and regulatory standards. These requirements serve as benchmarks for evaluating and improving data quality.',
              },
              {
                  id: 'DQ1.3',
                  text: 'Data Quality Assessment: The framework outlines processes for assessing data quality against predefined criteria. This includes methods for detecting data anomalies, measuring data quality metrics, and identifying areas for improvement.',
              },
              {
                  id: 'DQ1.4',
                  text: 'Data Quality Improvement: ISO 5259-4:2024 emphasizes continuous improvement in data quality. It provides guidance on implementing corrective actions, refining data quality processes, and ensuring that improvements are sustainable over time.',
              },
              {
                  id: 'DQ1.5',
                  text: 'Data Governance and Stewardship: The framework integrates data governance practices, ensuring that roles and responsibilities for data quality management are clearly defined. This includes the establishment of data stewards who are accountable for maintaining data quality.',
              },
              {
                  id: 'DQ1.6',
                  text: 'Data Quality Tools and Techniques: The standard discusses various tools and techniques for data quality management, including data profiling, cleansing, validation, and enrichment. It encourages the use of automated tools to enhance efficiency and accuracy in data processing.',
              },
              {
                  id: 'DQ1.7',
                  text: 'Documentation and Reporting: Comprehensive documentation of data quality processes and outcomes is required. The framework also stresses the importance of transparent reporting to stakeholders, ensuring that data quality initiatives are well-communicated and understood.',
              },
             

          ]
        },
      ]
    }
      
  ];

  const [answers, setAnswers] = useState({});

  useEffect(() => {
    const user = getUserId();
    if (user) {
      loadUserAnswersFromFirebase(user).then((loadedAnswers) => {
        console.log("Loaded answers from Firebase:", loadedAnswers);  // Debugging: log loaded answers
        setAnswers(loadedAnswers || {}); // Load saved answers or use an empty object
        console.log("Answers state after setting:", loadedAnswers || {});
      });
    }
  }, []);

  //Autosave Function every 1 second also calulating the averages for cyber risk score 
  useEffect(() => {

      const autoSaveInterval = setInterval(async () => {
        const user = getUserId()
        if (user) {
          try {
            await saveAnswersToFirebase(answers, user);

          } catch (error) {
            console.error('Error in auto-save:', error);
          }
        }
      }, 1000);
      return () => clearInterval(autoSaveInterval);
  }, [answers]);
  //Not allow scrolling when copilot is open 

 //manage the groups
 const groupedClauses = questions.reduce((groups, { groupTitle, goals }) => {
  if (!groups[groupTitle]) groups[groupTitle] = [];
  goals.forEach((goal) => {
    groups[groupTitle].push({ ...goal, requirements: [...goal.requirements] });
  });
  return groups;
}, {});

 
 // console.log('Grouped Clauses = ', groupedClauses)
 const getUserId = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const userId = searchParams.get('id');
  return userId;
};
  /* Checks if all the questions have been answered for the first time the user will be redirected to the dashboard then after that they wont 
  be and they can change their answers and they will be saved*/

  const d = new Date();
  let year = d.getFullYear();

  //HTML for the frontend
  return (
    <div >
      <div className="AssessmentContent">
          <>
            <h2 className='titleText'>AI Trustworthiness Assessment Tool: Evaluating Alignment with Responsible AI Guidelines</h2>
            {/*<p className='sloganText'>Empowering AI Innovations with Clear, Responsible Guidelines.</p>*/}
            {Object.entries(groupedClauses).map(([groupTitle, groupClauses], index) => (
            <CollapsibleTitle key={index} title={groupTitle} answers={answers} groupTitle={groupTitle} setAnswers={setAnswers}>
              {groupClauses.map((goal, goalIndex) => (
                <CollapsibleGoal
                  key={goalIndex}
                  goal={goal}
                  groupTitle={groupTitle}
                  setAnswers={setAnswers}
                  answers={answers}
                />
              ))}
            </CollapsibleTitle>
          ))}
            </>
          <p className='copyright'>© Copyright, {year} Assentian. All Rights Reserved</p>
      </div>
     </div> 
  );
};

export default AdminConformityAssessment;


